export default {
    key: 'swp',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    isUsingProductPresets: true,
    hideCrossSells: false,
    disablePassengers: false,
    activityId: '3cd1d151-f212-4045-a33d-168e47b202e9',
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: true,
    isUsingReductionCards: false,
    isUsingKeyCards: true,
    isUsingPromos: true,
    isPromotionRequired: false,
    showDuration: true,
    upsells: ['upsell-joch-winter', 'upsell-first-flyer', 'upsell-first-glider'],
    salesTimeLimit: 1020, // 17:00
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: 10,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: false,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: 'JB_SWP_PASS',
    listingId: '3cd1d151-f212-4045-a33d-168e47b202e9',
    isLocalListing: true,
    steps: [
        {
            routeName: 'offerFlow-swp-steps-step-1-date',
            name: 'offerFlow.pages.stepDate.name.common',
        },
        {
            routeName: 'offerFlow-swp-steps-step-2-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
            skipIfUpsell: true,
        },
    ],
} satisfies ProductConfigActivity;
